export const OnlinePaymentProvider = {
    ONEPAY: "OnePay"
}